import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import EinsteinLogo from '../../static/img/einstein-icon-36x36.svg';
import { PageHeader } from '@salesforce/design-system-react';

import './EctHeader.scss';
import { Link } from 'react-router-dom';

class EctHeader extends Component {
  blockLinkNavigation(e, criteria) {
    if (this.props.modalData) {
      const { name, unsavedChangesMessage } = this.props.modalData;
      if (!!criteria) {
        this.props.actions.openModal(name, unsavedChangesMessage);
        e.preventDefault();
      }
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { route } = this.props;

    const trailItems = [];
    let title = '';

    const icon = (
      <img
        className="einstein-logo"
        src={EinsteinLogo}
        alt="Einstein Logo"
        height="36px"
        width="36px"
      />
    );
    const classname = 'einstein-page-header';

    const EXPERIMENTS = (
      <Link to={{ pathname: '/experiments' }}>
        <FormattedMessage id="components.ecs.nav.experiments" />
      </Link>
    );

    // for title location purposes
    const EMPTY_BREADCRUMB = <span className="static-breadcrumb" />;

    switch (route.path) {
      case '/experiments':
        trailItems.push(EMPTY_BREADCRUMB);
        title = formatMessage({ id: 'components.ecs.nav.experiments' });
        break;

      case '/experiments/analytics/:experimentId':
        trailItems.push(EXPERIMENTS);
        title = this.props.experiment?.name;
        break;

      default:
        break;
    }

    return (
      <PageHeader
        title={title}
        icon={icon}
        variant="object-home"
        trail={trailItems}
        className={classname}
        onRenderActions={this.props.onRenderActions}
      />
    );
  }
}

EctHeader.propTypes = {
  route: PropTypes.object,
  onRenderActions: PropTypes.func,
  details: PropTypes.array,
  experiment: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(EctHeader);
